import { Theme } from "@mui/material/styles";
import { SxProps } from "@mui/system";

// Base utility styles - use SxProps for spreadable objects
export const flexRow: SxProps<Theme> = {
  display: "flex",
  flexDirection: "row",
};

export const flexColumn: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
};

export const flexWrap: SxProps<Theme> = {
  flexWrap: "wrap",
};

export const alignItemsCenter: SxProps<Theme> = { alignItems: "center" };
export const alignItemsFlexStart: SxProps<Theme> = { alignItems: "flex-start" };
export const alignItemsFlexEnd: SxProps<Theme> = { alignItems: "flex-end" };
export const justifyContentCenter: SxProps<Theme> = { justifyContent: "center" };
export const justifyContentFlexEnd: SxProps<Theme> = { justifyContent: "flex-end" };
export const justifyContentSpaceBetween: SxProps<Theme> = { justifyContent: "space-between" };

export const flexRowCenterCenter: SxProps<Theme> = {
  ...flexRow,
  ...alignItemsCenter,
  ...justifyContentCenter,
  zIndex: 10,
};

export const flexColumnCenterCenter: SxProps<Theme> = {
  ...flexColumn,
  ...alignItemsCenter,
  ...justifyContentCenter,
};

export const flexRowCenter: SxProps<Theme> = {
  ...flexRow,
  ...alignItemsCenter,
};

export const forgotPasswordBox: SxProps<Theme> = {
  display: "flex",
  ...alignItemsFlexEnd,
  ...justifyContentFlexEnd,
  height: "40px",
};

export const dropzoneStyles: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  height: "60px",
  width: "60px",
  justifyContent: "center",
  alignItems: "center",
  border: "2px solid #cccccc",
  borderRadius: "100%",
  padding: "10px",
  textAlign: "center",
  cursor: "pointer",
};

export const imageStyles: SxProps<Theme> = {
  maxWidth: "100%",
  maxHeight: "150px",
  height: "80px",
  width: "80px",
  backgroundSize: "contain",
  objectFit: "cover",
  objectPosition: "50% 0",
  borderRadius: "100%",
};

export const alignPatientIntakeHeadingIconStyle: SxProps<Theme> = {
  cursor: "pointer",
  position: "relative",
  top: 2,
};

export const loader: SxProps<Theme> = {
  animation: "spin 1s linear infinite",
  "@keyframes spin": {
    "0%": { transform: "rotate(0deg)" },
    "100%": { transform: "rotate(-360deg)" },
  },
};
